import { ReactNode } from "react";

export default function ListItem(props: {
  label: string;
  className?: string;
  value: ReactNode;
}) {
  const { label, value, className } = props;

  return (
    <div className={className}>
      <dt className="form-label">{label}</dt>
      <dd className="form-control--value">{value}</dd>
    </div>
  );
}
